import {Component, Input, OnChanges} from '@angular/core';
import { BaseRecordTableItemComponent } from '../../base-record-table-item/base-record-table-item.component';
import { MatDatepicker } from '@angular/material/datepicker';
import {customYearProvider} from "../../../../../locale/providers/custom-year.provider";

@Component({
  selector: 'app-year-record-table-item',
  standalone: false,
  templateUrl: './year-record-table-item.component.html',
  styleUrls: [
    '../../base-record-table-item-styles.scss',
    '../date-record-table-item/date-record-table-item.component.scss',
    './year-record-table-item.component.scss'
  ],
  providers: [ ...customYearProvider ]
})
export class YearRecordTableItemComponent extends BaseRecordTableItemComponent implements OnChanges {
  @Input() isFilter: boolean = false;
  private currentDate: string = '';

  public ngOnChanges(): void {
    this.currentDate = this.value?.toString() || '';
  }

  public onInputBlur(): void {
    if (!this.value) {
      this.value = this.currentDate;
      return;
    }

    const year = new Date(this.value.toString()).getFullYear();
    this.value = year.toString();
    super.handleValueChange(this.value);
  }

  public handleYearInputChange(date: string, datepicker: MatDatepicker<any>): void {
    const selectedDate = new Date(date);
    datepicker.close();
    this.value = selectedDate.getFullYear().toString();
    super.handleValueChange(this.value);
  }
}
